// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_uD-1o","sub_logo":"index_sub_logo_wu3U-","breadcrumbs":"index_breadcrumbs_tgrXr"};